module.exports = __webpack_public_path__ + "img/fiorentina-logo-icon.7cd946e4.png";